import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const footerLinks = {
    'For Job Seekers': [
      { label: 'Browse Jobs', path: '/jobs' },
      { label: 'Companies', path: '/companies' },
      { label: 'Career Resources', path: '/resources' },
      { label: 'Resume Builder', path: '/resume-builder' },
    ],
    'For Employers': [
      { label: 'Post a Job', path: '/employer/post-job' },
      { label: 'Browse Resumes', path: '/employer/resumes' },
      { label: 'Recruitment Solutions', path: '/employer/solutions' },
      { label: 'Pricing', path: '/employer/pricing' },
    ],
    'Company': [
      { label: 'About Us', path: '/about' },
      { label: 'Contact', path: '/contact' },
      { label: 'Privacy Policy', path: '/privacy' },
      { label: 'Terms & Conditions', path: '/terms' },
    ],
    'Legal': [
      { label: 'Shipping & Delivery', path: '/shipping' },
      { label: 'Cancellation & Refund', path: '/refund' },
      { label: 'Platform Disclaimer', path: '/disclaimer' },
    ],
  };

  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-8">
          {/* Brand & Contact Section */}
          <div className="col-span-1 md:col-span-2 lg:col-span-2">
            <h3 className="text-white text-lg font-semibold mb-4">Udaan Jobs</h3>
            <p className="text-sm text-gray-400 mb-4">
              Connecting talent with opportunity. Your next career move starts here.
            </p>

            {/* Contact Information */}
            <div className="space-y-3 mb-6">
              <h4 className="text-white text-sm font-semibold">Contact Us</h4>

              <div className="flex items-start gap-2">
                <svg className="w-5 h-5 text-gray-400 mt-0.5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                </svg>
                <p className="text-sm text-gray-400">
                  Sangli, Maharashtra 416415
                </p>
              </div>

              <div className="flex items-center gap-2">
                <svg className="w-5 h-5 text-gray-400 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
                <a href="mailto:support@udaanjobs.com" className="text-sm text-gray-400 hover:text-white transition-colors">
                  support@udaanjobs.com
                </a>
              </div>

              <div className="flex items-center gap-2">
                <svg className="w-5 h-5 text-gray-400 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                </svg>
                <a href="tel:7666110898" className="text-sm text-gray-400 hover:text-white transition-colors">
                  7666110898 /8554903120
                </a>
              </div>
            </div>

            {/* Social Icons */}
            <div className="flex space-x-4">
              {/* Facebook */}
              <a
                href="https://www.facebook.com/profile.php?id=61581514521770"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-white transition-colors"
              >
                <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M22.675 0h-21.35C.595 0 0 .593 0 1.326v21.348C0 23.406.595 24 1.325 24h11.494v-9.294H9.692v-3.622h3.127V8.413c0-3.1 1.894-4.788 4.659-4.788 1.325 0 2.464.099 2.797.143v3.24h-1.921c-1.506 0-1.799.716-1.799 1.766v2.316h3.595l-.468 3.622h-3.127V24h6.127C23.406 24 24 23.406 24 22.674V1.326C24 .593 23.406 0 22.675 0z" />
                </svg>
              </a>

              {/* Instagram */}
              <a
                href="https://www.instagram.com/udaanjobss/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-white transition-colors"
              >
                <svg className="h-6 w-6" fill="currentColor" view
                  Box="0 0 24 24">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 1.17.056 1.97.24 2.427.403a4.92 4.92 0 011.773 1.153 4.92 4.92 0 011.153 1.773c.163.457.347 1.257.403 2.427.058 1.266.07 1.646.07 4.85s-.012 3.584-.07 4.85c-.056 1.17-.24 1.97-.403 2.427a4.92 4.92 0 01-1.153 1.773 4.92 4.92 0 01-1.773 1.153c-.457.163-1.257.347-2.427.403-1.266.058-1.646.07-4.85.07s-3.584-.012-4.85-.07c-1.17-.056-1.97-.24-2.427-.403a4.92 4.92 0 01-1.773-1.153 4.92 4.92 0 01-1.153-1.773c-.163-.457-.347-1.257-.403-2.427C2.175 15.747 2.163 15.367 2.163 12s.012-3.584.07-4.85c.056-1.17.24-1.97.403-2.427A4.92 4.92 0 013.789 2.95a4.92 4.92 0 011.773-1.153c.457-.163 1.257-.347 2.427-.403C8.416 2.175 8.796 2.163 12 2.163zm0 1.837c-3.17 0-3.548.012-4.796.07-1.04.048-1.602.218-1.975.363-.497.192-.853.423-1.227.797a3.09 3.09 0 00-.797 1.227c-.145.373-.315.935-.363 1.975-.058 1.248-.07 1.626-.07 4.796s.012 3.548.07 4.796c.048 1.04.218 1.602.363 1.975.192.497.423.853.797 1.227.374.374.73.605 1.227.797.373.145.935.315 1.975.363 1.248.058 1.626.07 4.796.07s3.548-.012 4.796-.07c1.04-.048 1.602-.218 1.975-.363a3.09 3.09 0 001.227-.797 3.09 3.09 0 00.797-1.227c.145-.373.315-.935.363-1.975.058-1.248.07-1.626.07-4.796s-.012-3.548-.07-4.796c-.048-1.04-.218-1.602-.363-1.975a3.09 3.09 0 00-.797-1.227 3.09 3.09 0 00-1.227-.797c-.373-.145-.935-.315-1.975-.363-1.248-.058-1.626-.07-4.796-.07zm0 3.905a5.932 5.932 0 110 11.865 5.932 5.932 0 010-11.865zm0 9.8a3.868 3.868 0 100-7.735 3.868 3.868 0 000 7.735zm6.406-10.845a1.44 1.44 0 11-2.88 0 1.44 1.44 0 012.88 0z" />
                </svg>
              </a>

              {/* LinkedIn */}
              <a
                href="https://www.linkedin.com/company/109546107/admin/page-posts/published/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-white transition-colors"
              >
                <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M20.447 20.452h-3.554v-5.569c0-1.327-.027-3.037-1.85-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.354V9h3.414v1.561h.049c.476-.9 1.635-1.85 3.366-1.85 3.595 0 4.26 2.368 4.26 5.448v6.293zM5.337 7.433a2.062 2.062 0 11.002-4.124 2.062 2.062 0 01-.002 4.124zM6.96 20.452H3.713V9h3.247v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.205 24 24 23.227 24 22.271V1.729C24 .774 23.205 0 22.225 0z" />
                </svg>
              </a>
            </div>
          </div>

          {/* Links Sections */}
          {Object.entries(footerLinks).map(([title, links]) => (
            <div key={title} className="col-span-1">
              <h3 className="text-white text-sm font-semibold mb-4">{title}</h3>
              <ul className="space-y-2">
                {links.map((link) => (
                  <li key={link.path}>
                    <Link to={link.path} className="text-sm text-gray-400 hover:text-white transition-colors">
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 text-sm text-gray-400">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p>&copy; {new Date().getFullYear()} Udaan Jobs. All rights reserved.</p>
            <div className="mt-4 md:mt-0 flex flex-wrap gap-4 justify-center">
              <Link to="/privacy" className="hover:text-white">Privacy Policy</Link>
              <Link to="/terms" className="hover:text-white">Terms & Conditions</Link>
              <Link to="/shipping" className="hover:text-white">Shipping & Delivery</Link>
              <Link to="/refund" className="hover:text-white">Cancellation & Refund</Link>
              <Link to="/disclaimer" className="hover:text-white">Platform Disclaimer</Link>
              <Link to="/delete-account" className="hover:text-white">Delete Account</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
